import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import bgImg from './frame-bg.webp';

type ProgressCardProps = {
  progressPercent: number;
};

export const ProgressCard = ({ progressPercent }: ProgressCardProps) => {
  return (
    <Box
      sx={{
        borderRadius: '15px',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        minHeight: 155,
        backgroundImage: `url(${bgImg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontFamily: '"Fraunces", sans-serif',
          fontWeight: 'bold',
          mb: 1,
          fontSize: '20px',
          color: theme => theme.palette.common.white,
        }}
      >
        Great Progress!
      </Typography>
      <Typography variant="body2" sx={{ fontSize: '13px', color: theme => theme.palette.common.white }}>
        You completed{' '}
        <Typography
          component="span"
          sx={{
            fontWeight: 'bold',
            fontSize: '20px !important',
            fontFamily: '"Fraunces", sans-serif',
          }}
        >
          {progressPercent}%
        </Typography>{' '}
        of the lesson!
      </Typography>
    </Box>
  );
};
